module.exports = __webpack_public_path__ + "static/media/multas_web_autopistas.2ce0964a.svg";